











import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class ToggleInactiveUsersButton extends Vue {
    @Prop() readonly value!: boolean
    internalValue: boolean = false

    mounted(): void {
        this.onValueChanged()
    }

    @Watch('value')
    onValueChanged(): void {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    onInternalValueChanged(): void {
        this.$emit('input', this.internalValue)
    }
}
